import { ScrollView } from "@-/com.npmjs.react-native";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { MorphemeInfoPanelContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._context";
import {
  MorphemeInfoPanelCaligraphyStrokesSurface,
  MorphemeInfoPanelCaligraphyWordStrokesSurface,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.caligraphy.__sections.strokes";

/**
 * The stroke order as a surface on the page background, 9px from the screen edges like the other
 * Details tabs' surfaces. Evolution (`__sections/evolution`) is disabled for now.
 */
export function MorphemeInfoPanelCaligraphyTab() {
  const [infoBackCardSlice, setIsScrolled, floatingTabBottomInset] = useContextSelectors(
    MorphemeInfoPanelContext,
    (c) => c.infoBackCardSlice.data,
    (c) => c.setIsScrolled,
    (c) => c.floatingTabBottomInset,
  );

  return (
    <ScrollView
      className="flex-1 bg-background"
      contentContainerClassName="p-2.25"
      // Clear the floating tab bar, then keep the 9px gutter below the surface.
      contentContainerStyle={{ paddingBottom: floatingTabBottomInset + 9 }}
      onScroll={(event) => setIsScrolled(event.nativeEvent.contentOffset.y > 0)}
      scrollEventThrottle={16}
      testID="morpheme-info-caligraphy-tab"
    >
      {infoBackCardSlice.morphemeType === "word" ? (
        <MorphemeInfoPanelCaligraphyWordStrokesSurface wordCard={infoBackCardSlice} />
      ) : (
        <MorphemeInfoPanelCaligraphyStrokesSurface graphemeCard={infoBackCardSlice} />
      )}
    </ScrollView>
  );
}
